import { render, staticRenderFns } from "./ServerStats.vue?vue&type=template&id=25b58b04&scoped=true&"
import script from "./ServerStats.vue?vue&type=script&lang=js&"
export * from "./ServerStats.vue?vue&type=script&lang=js&"
import style0 from "./ServerStats.vue?vue&type=style&index=0&id=25b58b04&lang=scss&scoped=true&"
import style1 from "./ServerStats.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b58b04",
  null
  
)

export default component.exports